import React from "react";

export type FormHoneypotProps = Wif.Mgnl.Node & {
  controlName: string;
};

export default function FormHoneypot(
  props: FormHoneypotProps
): React.JSX.Element | null {
  const { controlName } = props;

  return (
    <>
      <input type="text" name={controlName} style={{ display: "none" }} />
    </>
  );
}
